// extracted by mini-css-extract-plugin
module.exports = {"file":"ProfUnionsViewConfirmDocument_file__1NLb2","size":"ProfUnionsViewConfirmDocument_size__2iy9f"};